import React from 'react';
import styled from 'styled-components';

const RadioTabs = ({ options, selectedValue, onChange, language = 'es' }) => {
  return (
    <StyledWrapper>
      <div className="radio-inputs">
        {options.map((option, index) => (
          <label key={option.value}>
            <input
              className="radio-input"
              type="radio"
              name="project-category"
              value={option.value}
              checked={selectedValue === option.value}
              onChange={() => onChange(option.value)}
            />
            <span className="radio-tile">
              <span className="radio-icon">
                {option.icon}
              </span>
              <span className="radio-label">{option.label}</span>
            </span>
          </label>
        ))}
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  /* From Uiverse.io by Yaya12085 - Modified for Dark Mode */
  .radio-inputs {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    flex-wrap: wrap;
    gap: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .radio-inputs > * {
    margin: 6px;
  }

  .radio-input:checked + .radio-tile {
    border-color: #4d8bff;
    box-shadow: 0 5px 10px rgba(77, 139, 255, 0.3);
    color: #4d8bff;
    background-color: #2a3445;
  }

  .radio-input:checked + .radio-tile:before {
    transform: scale(1);
    opacity: 1;
    background-color: #4d8bff;
    border-color: #4d8bff;
  }

  .radio-input:checked + .radio-tile .radio-icon svg {
    fill: #4d8bff;
    stroke: #4d8bff;
  }

  .radio-input:checked + .radio-tile .radio-label {
    color: #4d8bff;
  }

  .radio-input:focus + .radio-tile {
    border-color: #4d8bff;
    box-shadow:
      0 5px 10px rgba(255, 255, 255, 0.1),
      0 0 0 4px #3a6abf;
  }

  .radio-input:focus + .radio-tile:before {
    transform: scale(1);
    opacity: 1;
  }

  .radio-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
    min-height: 100px;
    padding: 12px;
    border-radius: 0.75rem;
    border: 2px solid #4a5265;
    background-color: #1e2129;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    transition: 0.15s ease;
    cursor: pointer;
    position: relative;
  }

  .radio-tile:before {
    content: "";
    position: absolute;
    display: block;
    width: 0.75rem;
    height: 0.75rem;
    border: 2px solid #4a5265;
    background-color: #1e2129;
    border-radius: 50%;
    top: 0.5rem;
    left: 0.5rem;
    opacity: 0;
    transform: scale(0);
    transition: 0.25s ease;
  }

  .radio-tile:hover {
    border-color: #4d8bff;
    transform: translateY(-2px);
    box-shadow: 0 8px 15px rgba(77, 139, 255, 0.2);
  }

  .radio-tile:hover:before {
    transform: scale(1);
    opacity: 1;
  }

  .radio-icon svg {
    width: 2.5rem;
    height: 2.5rem;
    fill: #b6b6b6;
    stroke: #b6b6b6;
    transition: 0.3s ease;
  }

  .radio-label {
    color: #8f8f8f;
    transition: 0.375s ease;
    text-align: center;
    font-size: 13px;
    margin-top: 8px;
    font-weight: 500;
  }

  .radio-input {
    clip: rect(0 0 0 0);
    -webkit-clip-path: inset(100%);
    clip-path: inset(100%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  @media (max-width: 640px) {
    .radio-tile {
      width: 90px;
      min-height: 90px;
      padding: 10px;
    }

    .radio-icon svg {
      width: 2rem;
      height: 2rem;
    }

    .radio-label {
      font-size: 11px;
    }
  }
`;

export default RadioTabs;
